import React, { useEffect, useState } from "react";
import MMTransactions from "../../Components/Transactions/MMTransactions";
import AppContainer from "../../Components/Structure/AppContainer";
import MMCollectionsCategorizedChart from "../../Components/Transactions/MMCollectionsCategorizedChart";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ajaxBank from "../../util/remote/ajaxBank";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {Toaster} from "react-hot-toast";

function MobileMoneyPage() {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);
  const [mmCollectionsToday, setMMCollectionsToday] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  // useEffect(() => {
  //       getMMCollectionsToday();
  
  //   }, []);

  useEffect(() => {
      const fetchAll = async () => {
        setLoadingPage(true);
        await Promise.all([
          getMMCollectionsToday(),
        ]);
        setLoadingPage(false);
      };
    fetchAll();
    }, []);

  const getMMCollectionsToday = async () => {
      const server_response = await ajaxBank.fetchMMCollectionsToday();
      if (server_response.status === "OK") {
        setMMCollectionsToday(server_response.details.totals);
      } else {
        setMMCollectionsToday(false);
      }
  };

  return (
    <AppContainer title="Mobile Money Transactions">
      <Toaster position="top-center" reverseOrder={false} />
      
      {loadingPage ? (
                    // Full page skeleton loader
                    <div style={{ padding: 40 }}>
                      <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                      <Skeleton height={200} style={{ marginBottom: 20 }} />
                      <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                    </div>
                  ) : (<>
        <div className="row row-sm">
          <div className="col-lg-4">
              <div className="card custom-card">
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Transactions Today ({todayFormatted})</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Transaction Type</th>
                        
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                      <tr>
                        <td>Buzztime Load</td>
                        <td> UGX. {mmCollectionsToday ? mmCollectionsToday.buzztime_load.total_c :"0"}</td>
                      </tr>
                      <tr>
                        <td>Pocket Money Deposits</td>
                        <td> UGX. {mmCollectionsToday ? mmCollectionsToday.pm_deposit.total_c : "0"}</td>
                      </tr>
                      <tr>
                        <td>Card Activations</td>
                        <td> UGX. {mmCollectionsToday? mmCollectionsToday.card_activation.total_c: "0"}</td>
                      </tr>
                      <tr>
                        <td>Wristband Activations</td>
                        <td> UGX. {mmCollectionsToday? mmCollectionsToday.wristband_activation.total_c: "0"}</td>
                      </tr>
                      <tr>
                        <td>Card Replacements</td>
                        <td> UGX. {mmCollectionsToday? mmCollectionsToday.card_replace.total_c: "0"}</td>
                      </tr>
                      <tr>
                        <td>Wristband Replacements</td>
                        <td> UGX. {mmCollectionsToday? mmCollectionsToday.wristband_replace.total_c :"0"}</td>
                      </tr>
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        <div className="col-lg-8 col-md-12 col-12 col-sm-12 mt-lg-0 mt-sm-4">
                <div class="card">
                  <div class="card-body">

                    <MMCollectionsCategorizedChart/>
                   
                  </div>
                </div>      
        </div>
        
      </div>
        <div className="row">
            <div className="col-lg-12 col-md-12 mt-3">
            <div className="card custom-card">
                    <div className="card-body map-card">
                        <MMTransactions/>
                    
                    </div>
                </div>
            </div>
        </div></>)}
     
    </AppContainer>
  );
}

export default MobileMoneyPage;